module.exports = __webpack_public_path__ + "img/cns_ios11.5d2d1421.png";